import "./Academy.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../Auth.js";
import { Nav } from "../components/home-page/nav-section";
import AcademyDrawer from "../components/drawers/AcademyDrawer.jsx";
import { courses } from "../data/academyData";
import { effectiveTier, canAccessAcademy } from "../data/tierAccess";
import AccessGateModal from "../components/AccessGateModal";

export default function Academy() {
  const { currentUser, authUserData } = useContext(AuthContext);
  const navigate = useNavigate();
  const [expandedCourse, setExpandedCourse] = useState(null);
  const [gated, setGated] = useState(false);

  useEffect(() => {
    // Truly unauthenticated users must sign in first.
    if (!currentUser) {
      navigate("/login");
      return;
    }
    // Wait for the (lazily-created) user doc to resolve.
    if (authUserData === undefined || authUserData === null) {
      return;
    }
    // Academy is premium-only. Any insufficient tier (no license, Parents, or
    // Regular) gets the upgrade modal instead of a silent /account bounce.
    setGated(!canAccessAcademy(effectiveTier(authUserData)));
  }, [currentUser, authUserData, navigate]);

  return (
    <div>
      <Nav />
      <AccessGateModal
        open={gated}
        title="A Premium feature"
        requiredTier="premium"
        message={
          "The Academy is available on the Premium plan. Upgrade to Premium " +
          "to access the courses, handouts and assessment tools."
        }
        actions={[
          { label: "View plans", onClick: () => navigate("/purchase"), primary: true },
          { label: "Go to my account", onClick: () => navigate("/account") },
          { label: "Back to home", onClick: () => navigate("/") },
        ]}
      />
      {!gated && (
        <>
          <div style={{ width: "80px" }}>
            <AcademyDrawer setExpandedCourse={setExpandedCourse} />
          </div>
          <div className="courseContainer">
        {expandedCourse !== null ? (
          <div className="expandedCourse">
            <h2>{courses[expandedCourse].name}</h2>
            <iframe
              width="560"
              height="315"
              src={`https://streamable.com/e/${courses[expandedCourse].embedId}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title={courses[expandedCourse].name}
            ></iframe>
            <p><strong>Objectives:</strong> {courses[expandedCourse].objectives}</p>
            {courses[expandedCourse].handout && (
              <a
                href={courses[expandedCourse].handout}
                download
                className="downloadButton"
              >
                Download Handout
              </a>
            )}
          </div>
        ) : (
          <div className="expandedCourse">
            <img className="landingImage" alt="" src={"\\Academy\\AcademyLandingPage.png"}></img>
          </div>
        )}
          </div>
        </>
      )}
    </div>
  );
}